export default class ApiClient {

    constructor() {
        // this.appBaseUrl = import.meta.env.VITE_APP_URL;
        // this.apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
        // this.apiVersionEntryPoint = import.meta.env.VITE_API_VERSION_ENTRY_POINT;

        this.appBaseUrl = import.meta.env.VITE_APP_URL;
        this.apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
        this.apiVersionEntryPoint = import.meta.env.VITE_API_VERSION_ENTRY_POINT;
        
        this.apiUrl = this.apiBaseUrl + this.apiVersionEntryPoint;
        this.appCallUrl = this.appBaseUrl;
    }

    getAdsList(filters = {}) {
        return axios.post(this.apiUrl + '/requests_resource/utility/research', {filters:filters})
    }

    getFilteredAdsList(filters = {}, singleadid = 0) {

        let _apiToken = window.apiToken;
        let searchAdsUrlPath = _apiToken ?  `/search-ads-auth?api_token=${_apiToken}` : '/search-ads';

        if ( singleadid ) {
            return axios.post(this.apiUrl + searchAdsUrlPath, {id:singleadid}) // to just get 1 single ad, 
        } else {
            return axios.post(this.apiUrl + searchAdsUrlPath, {filters:filters})
        }
    }


    getFilteredProfessionalsList(filters = {}) {
        let _apiToken = window.apiToken;
        return axios.post(this.apiUrl + `/search-professionals?api_token=${_apiToken}`, {filters:filters})
    }

    getFilteredProfessionalsListPublic(filters = {}) {
        let _apiToken = window.apiToken;
        return axios.post(this.apiUrl + `/search-professionals-public`, {filters:filters, is_public: 1})
    }

    getFilteredBusinessList(filters = {}) {
        return axios.post(this.apiUrl + '/business/utility/search', { filters: filters }, {
            params: {
                api_token: window.apiToken
            }
        });
    }

  

    getBusinessAdsList(id, status = false, page = 1, perPage = 10, sort = null, sort_order = 'asc', search_text = "", search_column = "all", filters = {}) {
        const endpoint = id === 0 
            ? '/requests_resource/utility/Ads' 
            : `/requests_resource/utility/structure/${id}`;
        
        return axios.get(`${this.apiUrl}${endpoint}`, {
            params: {
                api_token: window.apiToken,
                status: status,
                page: page,
                perPage: perPage,
                sort: sort,
                sort_order: sort_order,
                search_text: search_text,
                search_column: search_column,
                ...filters
            }
        });
    }
    

    getBusinessDetails(id, ad_id) {
        return axios.get(this.apiUrl + '/business/utility/business-details/' + id, {
            params: {
                api_token: window.apiToken,
                ad_id,
            }
        });
    }

    getBusinessAdminDetails(id) {
        return axios.get(this.apiUrl + '/business/utility/business-admin-details/' + id, {
            params: {
                api_token: window.apiToken,
            }
        });
    }

    getAdCandidaturesList(ad_id) {
        return axios.get(this.apiUrl + '/candidatures/utility/requests/'+ad_id,
            {
                params: {
                    api_token: window.apiToken
                }
            });
    }

    getMasterDetails(id, extraParams = {}) {
        return axios.get(this.apiUrl + '/professional/utility/public-show/'+id,
            {
                params: {
                    api_token: window.apiToken,
                    ...extraParams
                }
            });
    }

    getMasterCandidaturesList( postData ) {
        return axios.get(this.apiUrl + '/applications/utility/me',
            {
                params: {
                    api_token: window.apiToken,
                    active_results: postData.active_results,
                    status: postData.status,
                    ad_status: postData.ad_status,
                    profid: postData.profid,
                    perPage: postData.perPage,
                    page: postData.page,
                    ad_id: postData.ad_id,
                }
            });
    }

    doPostLogin(email, password, remember, intended) {
        return axios.post(this.appCallUrl+'/login', {
            email: email,
            password: password,
            remember: remember,
            intended: intended
        });
    }

    sendPasswordResetEmail(email) {
        return axios.post(this.appCallUrl + '/password/email', {
            email: email
        }, {
            headers: {
                'Accept': 'application/json'
            }
        });
    }

    resetPassword(payload) {
        return axios.post(this.appCallUrl + '/password/reset', {
            token: payload.token,
            email: payload.email,
            password: payload.password,
            password_confirmation: payload.password_confirmation
        }, {
            headers: {
                'Accept': 'application/json'
            }
        });
    }

    doLogout() {
        return axios.post(this.appCallUrl+'/logout');
    }

    toggleAdDisabled(ad_id) {
        return axios.get(this.apiUrl + '/requests_resource/utility/toggle-disable/'+ad_id, {
            params: {
                api_token: window.apiToken
            }
        })
    }


    // AI Description
    reviewDescriptionAi(description_text, ads_id = null) {
        const payload = { description_text };
        if (ads_id) {
            payload.ads_id = ads_id;
        }
        return axios.post(this.apiUrl + '/openai-api?api_token='+window.apiToken, payload)
    }


    // Business - candidature actions
    acceptCandidature(cnd_id) {
        return axios.post(this.apiUrl + '/applications/utility/'+cnd_id+'?api_token='+window.apiToken, {
            confirmed: 1
        })
    }


    

    refuseCandidature(cnd_id) {
        return axios.post(this.apiUrl + '/applications/utility/'+cnd_id+'?api_token='+window.apiToken, {
            confirmed: 0
        })
    }

    maybeCandidature(cnd_id) {
        return axios.post(this.apiUrl + '/applications/utility/'+cnd_id+'?api_token='+window.apiToken, {
            confirmed: 2
        })
    }

    addAds(data) {
        return axios.post(this.apiUrl + '/requests_resource?api_token='+window.apiToken, data);
    }

    editAds(id, data) {
        return axios.put(this.apiUrl + '/requests_resource/'+id+'?api_token='+window.apiToken, data);
    }

    editAdsDescription(id, data) {
        return axios.put(this.apiUrl + '/requests_resource/utility/update-description/'+id+'?api_token='+window.apiToken, data);
    }

    adminDescriptionAction(id, data) {
        return axios.post(this.apiUrl + '/requests_resource/utility/description-action/'+id+'?api_token='+window.apiToken, data);
    }

    updateAdStatus(id, data) {
        return axios.put(this.apiUrl + '/requests_resource/utility/update-status/'+id+'?api_token='+window.apiToken, data);
    }

    professionalApplyAd(id, data) {
        return axios.put(this.apiUrl + '/requests_resource/utility/update-status/'+id+'?api_token='+window.apiToken, data);
    }

    previewAd(data) {
        return axios.post(this.apiUrl + '/requests_resource/utility/ad-preview?api_token='+window.apiToken, data);
    }

    registerUser(data) {
        return axios.post(this.appCallUrl + '/register', data);
    }

    updateBusiness(id, data) {
        return axios.put(this.apiUrl+ '/business/'+id+'?api_token='+window.apiToken, data);
    }

    completeBusiness(data) {
        return axios.post(this.apiUrl+ '/business?api_token='+window.apiToken, data);
    }

    updateMaster(id, data) {
        return axios.put(this.apiUrl+ '/professional/'+id+'?api_token='+window.apiToken, data);
    }

    completeMaster(data) {
        return axios.post(this.apiUrl+ '/professional?api_token='+window.apiToken, data);
    }

    candidateToAd(ad_id, professional_id, message) {
        return axios.post(this.apiUrl+ '/applications?api_token='+window.apiToken, {
            ad_id: ad_id,
            professional_id: professional_id,
            message: message
        });
    }

    hireCandidate(application_id, ad_id, professional_id, hired = true) {
        return axios.put(this.apiUrl+ `/applications/utility/hire/${application_id}?api_token=`+window.apiToken, {
            ad_id: ad_id,
            professional_id: professional_id,
            hired: hired
        });
    }

    deleteBusinessContact(contact_id){
        return axios.delete(this.apiUrl+ '/business-contact/'+contact_id+'?api_token='+window.apiToken);
    }

    deleteBusinessLocation(location_id){
        return axios.delete(this.apiUrl+ '/business-location/'+location_id+'?api_token='+window.apiToken);
    }
    
    addBusinessLocation(data){
        return axios.post(this.apiUrl+ '/business-location?api_token='+window.apiToken, data);
    }
    updateBusinessLocation(id, data) {
        return axios.put(this.apiUrl+ '/business-location/'+id+'?api_token='+window.apiToken, data);
    }


    // Add / update business contact
    addBusinessContact(data){
        return axios.post(this.apiUrl+ '/business-contact?api_token='+window.apiToken, data);
    }
    updateBusinessContact(id, data) {
        return axios.put(this.apiUrl+ '/business-contact/'+id+'?api_token='+window.apiToken, data);
    }

    deleteProfessionalExperience(id){
        return axios.delete(this.apiUrl+ '/professional-experience/'+id+'?api_token='+window.apiToken);
    }
    
    addProfessionalExperience(data){
        return axios.post(this.apiUrl+ '/professional-experience?api_token='+window.apiToken, data);
    }
    
    updateProfessionalExperience(id, data) {
        return axios.put(this.apiUrl+ '/professional-experience/'+id+'?api_token='+window.apiToken, data);
    }


    getAddress(id) {
        return axios.get(this.apiUrl+ '/address/'+id+'?api_token='+window.apiToken);
    }



    /* Admin */
    adminUndeleteAd(id) {
        // return axios.get(this.apiUrl+ '/ads/undelete/'+id+'?api_token='+window.apiToken);
        return axios.post(this.apiUrl + '/requests_resource/utility/undeletead/'+id+'?api_token='+window.apiToken);
    }
}